import { EventPayloadType } from "@package/ui-gql/index-analytics";
import {
  type ActionPayloadType,
  type DeviceMenuLocation,
  type DeviceStatus,
  type IconType,
  type PostQrCodeBoxShape,
  type PostQrCodeSize,
  type ScreenType,
  type Templates,
} from "@package/ui-gql/index-data-access";

export const ITEM_GRID_QUERY_SEARCH_DEBOUNCE_MS = 250;
export const ITEM_GRID_PER_PAGE_DEFAULT = 10;
export const ITEM_GRID_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100];

export const SCREEN_TYPE_TO_DISPLAY: { [key in ScreenType]: string } = {
  custom: "LED",
  tv: "Standard",
};

export const ICON_TYPE_TO_DISPLAY: { [key in IconType]: string } = {
  media: "Media",
  text: "Text",
  textmedia: "Text and Media",
};

export const EVENT_TYPE_TO_DISPLAY: { [key in EventPayloadType]: string } = {
  [EventPayloadType.CacheReloadRequest]: "Cache Reload Request",
  [EventPayloadType.DeviceActive]: "Location Active",
  [EventPayloadType.DeviceStarted]: "Location Started",
  [EventPayloadType.PostActioned]: "Content Actioned",
  [EventPayloadType.PostClosed]: "Content Closed",
  [EventPayloadType.PostInteracted]: "Content Interacted",
  [EventPayloadType.PostShown]: "Content Shown",
  [EventPayloadType.PostTimeExtended]: "Content Time Extended",
  [EventPayloadType.PostTimedOut]: "Content Timed Out",
  [EventPayloadType.ProfileLoaded]: "Profile Loaded",
  [EventPayloadType.QrCode]: "QR Code",
  [EventPayloadType.RestingMediaInteracted]: "Resting Media Interacted",
  [EventPayloadType.RestingMediaStarted]: "Resting Media Started",
  [EventPayloadType.RestingMediaTimedOut]: "Resting Media Timed Out",
  [EventPayloadType.TriviaQuestion]: "Trivia Question",
  [EventPayloadType.SearchQuery]: "Search Query",
  [EventPayloadType.VideoSource]: "Video Source",
  [EventPayloadType.VideoInputDevices]: "Video Input Devices",
};

export const TEMPLATE_TO_DISPLAY: {
  [key in Templates]: string;
} = {
  Custom: "Custom",
  FiveByOne: "5x1",
  FiveByThree: "5x3",
  OneByFive: "1x5",
  OneByOne: "1x1",
  OneByThree: "1x3",
  ThreeByFive: "3x5",
  ThreeByOne: "3x1",
  TwoByTwo: "2x2",
  ZeroByZero: "0x0",
};

export const DEVICE_STATUS_TO_DISPLAY: { [key in DeviceStatus]: string } = {
  approved: "Approved",
  denied: "Denied",
  registered: "Registered",
};

export const DEVICE_MENU_LOCATION_TO_DISPLAY: {
  [key in DeviceMenuLocation]: string;
} = {
  none: "None",
  topleft: "Top Left",
  topright: "Top Right",
  bottomleft: "Bottom Left",
  bottomright: "Bottom Right",
};

export type ItemCreateDrawerProps = {
  isOpen: boolean;
  onCreated: (id?: string) => void;
  onClose: () => void;
};

export const QR_CODE_ENUM_TO_SIZE: { [key in PostQrCodeSize]: number } = {
  large: 256,
  medium: 192,
  small: 128,
};

export const POST_QR_CODE_DEFAULT_TEXT = "SCAN HERE LEARN MORE";
// Matches the original FlyoutQrCodePaddedContainer outer halo
// (`p-4 rounded-2xl bg-black/25`) that gives the box contrast over bright
// flyout media.
export const POST_QR_CODE_DEFAULT_BACKDROP_COLOR = "rgba(0, 0, 0, 0.25)";
export const POST_QR_CODE_BACKDROP_PADDING = "1rem";
export const POST_QR_CODE_BACKDROP_RADIUS = "1rem";
export const POST_QR_CODE_DEFAULT_BOX_COLOR = "#ffffff";
export const POST_QR_CODE_DEFAULT_TEXT_COLOR = "#000000";
export const POST_QR_CODE_DEFAULT_TEXT_SIZE = 36;
export const POST_QR_CODE_DEFAULT_QR_COLOR = "#000000";
export const POST_QR_CODE_DEFAULT_QR_BACKGROUND_COLOR = "#ffffff";
export const POST_QR_CODE_DEFAULT_BORDER_COLOR = "#000000";
export const POST_QR_CODE_BORDER_WIDTH = 2;
// Matches the box's own p-8 padding, so an edge-anchored QR still has
// breathing room instead of sitting flush against the border.
export const POST_QR_CODE_BOX_PADDING = "2rem";

export const POST_QR_CODE_BOX_SHAPE_TO_RADIUS: {
  [key in PostQrCodeBoxShape]: string;
} = {
  square: "0",
  rounded: "0.75rem",
  pill: "9999px",
};

export const ACTION_PAYLOAD_TYPE_TO_DISPLAY: {
  [key in ActionPayloadType]: string;
} = {
  ACTION_LOCATION_PROFILE_CHANGED: "Change Location Canvas",
  ACTION_POST_ENABLED: "Enable/Disable Content",
};
